import {
  GET_CAMPAIGN_METRICS,
  GET_CAMPAIGN_METRICS_SUCCESS,
  //GET_CAMPAIGN_METRICS_FAILURE,
} from './const'
import createMiddleware from 'Reducers/createMiddleware'
import { apiClient } from 'Module/API/Client'

export const getCampaignMetricsMiddleware = createMiddleware({
  actions: [GET_CAMPAIGN_METRICS, GET_CAMPAIGN_METRICS_SUCCESS],
  //TODO I don't think this is the correct format
  fetchMethod: payload => [apiClient.getCampaignMetrics, payload.campaignId],
})
